.content {
  z-index: var(--z-modal);
  color: var(--dropdown-color);
  background: var(--dropdown-background);
  border: 1px solid var(--dropdown-border-color);
  border-radius: 4px;
  box-shadow: var(--dropdown-shadow);
}

.pad {
  padding: 0.5rem;
}

.arrow {
  fill: var(--dropdown-background);
}
